export default "__VITE_ASSET__38ce7d38__"